import getAlert from './getAlert'

export const getAlertPromise = getAlert
